import Scrollbar from '../modules/scrollbar';
import bem from '../modules/bem';
import viewport from '../modules/viewport';

const variables = require('../../variables.json');

class OddsGrid {

	static get block() {
		return bem.block('odds-grid');
	}

	constructor($oddsGrid){

		this.$oddsGrid = {
			root: $oddsGrid,
			header: $oddsGrid.querySelector(OddsGrid.block.selector('header')),
			premium: $oddsGrid.querySelector(OddsGrid.block.selector('premium')),
			standard: $oddsGrid.querySelector(OddsGrid.block.selector('standard'))
		};
		this.$rows = {
			all: this.$oddsGrid.root.querySelectorAll('.odds-grid__row'),
			header: this.$oddsGrid.header.querySelectorAll('.odds-grid__row'),
			premium: this.$oddsGrid.premium
						? this.$oddsGrid.premium.querySelectorAll('.odds-grid__row')
						: null,
			standard: this.$oddsGrid.standard.querySelectorAll('.odds-grid__row'),
			horse: this.$oddsGrid.root.querySelectorAll('.odds-grid__row--horse')
		};
		this.$cells = {
			all: this.$oddsGrid.root.querySelectorAll('.odds-grid__cell'),
			odds: this.$oddsGrid.root.querySelectorAll('.odds-grid__cell--odds')
		};
		this.$allRunners = document.querySelector(OddsGrid.block.selector('all-runners'));
		this.$scrollbar = this.$oddsGrid.root.querySelector(bem.block('scrollbar').selector());

		this.header = {
			width: variables['odds-grid'].header
		};
		this.premium = {
			total: 0
		};
		this.standard = {
			total: this.$oddsGrid.standard.querySelector('.odds-grid__row').children.length
		};
		this.cellMin = variables['odds-grid'].cellMinWidth;
		this.overflow = {
			active: false
		};
		this.scrollbar = null;

		this.init = this.init.bind(this);
		this.onResize = this.onResize.bind(this);
		this.allRunnersToggle = this.allRunnersToggle.bind(this);

		this.init();
	}

	init(){

		// set totals
		if( this.$oddsGrid.premium ){
			this.premium.total = this.$oddsGrid.premium.querySelector('.odds-grid__row').children.length;

			// get premium padding (never changes size)
			const premiumStyle = window.getComputedStyle(this.$oddsGrid.premium);
			this.premium.padding = parseInt(premiumStyle.paddingRight, 10);
		}

		// resize
		viewport.addListener('odds-grid', this.onResize);
		this.onResize();

		// cell hovers & row/column highlighting
		$(this.$cells.odds)
			.on('mouseenter mouseleave', function(e){

				const $cell = $(this);
				const rowIndex = $cell.parent().index();
				const colIndex = $cell.index();
				const ev = e.type === 'mouseenter';

				// highlight column
				$cell
					.closest('.odds-grid__section')
					.find('.odds-grid__row')
					.each(function(){

						$(this)
							.find('.odds-grid__cell')
							.eq(colIndex)
							.toggleClass('is-highlighted', ev);

					});

				// highlight row
				$.each($('.odds-grid__row-wrapper--entries'), function(){

					const $group = $(this);

					$group
						.find('.odds-grid__row')
						.eq(rowIndex)
						.toggleClass('is-highlighted', ev);

				});

			});

		// show/hide all runners
		if( this.$allRunners ){
			// add listener
			this.$allRunners.addEventListener('change', this.allRunnersToggle);

			// set initial state if cookie
			if( userSettings.oddsGrid.allRunners ){
				this.$allRunners.checked = true;

				this.allRunnersToggle();
			}
		}

		// add scrollbar
		this.scrollbar = new Scrollbar(this.$scrollbar);

	}

	onResize(){

		// Calculate the width of stuff
		const cellMin = this.cellMin;
		const gridWidth = this.$oddsGrid.root.offsetWidth;
		const headerWidth = this.header.width;
		const premiumTotal = this.premium.total;
		const premiumPadding = this.premium.padding;
		const standardTotal = this.standard.total;

		let availableWidth = gridWidth - headerWidth;

		// this.premium.minWidth = (cellMin * premiumTotal) + premiumPadding;

		// if premium, include premium padding
		if( this.$oddsGrid.premium ) availableWidth -= premiumPadding;

		// define the cell width, so can calculate section widths
		let cellWidth = availableWidth / (premiumTotal + standardTotal);

		// console.log( cellWidth, cellMin );

		// check cellWidth isn't less than the min allowed
		// and based on cell width, does the content overflow?
		if( cellWidth < cellMin ){
			cellWidth = cellMin;
			this.overflow.active = true;
		}else{
			this.overflow.active = false;
		}

		// console.log( cellWidth, cellMin );

		// check and set premium widths
		if( this.$oddsGrid.premium ){
			const premiumWidth = (cellWidth * premiumTotal) + premiumPadding;

			this.$oddsGrid.premium.style.width = premiumWidth + 'px';

			this.$oddsGrid.root.style.paddingLeft = headerWidth + premiumWidth + 'px';
		}

		// set classes
		this.$oddsGrid.root.classList.toggle('odds-grid--has-scrollbar', this.overflow.active);

	}

	allRunnersToggle(){

		const $checkbox = this.$allRunners;
		const checked = $checkbox.checked;

		this.$oddsGrid.root.classList.toggle('odds-grid--show-all', checked);

		// update global cookie
		userSettings.oddsGrid.allRunners = checked;
		updateUserSettings();

	}

}

module.exports = () => {
	const $oddsGrid = document.querySelector(OddsGrid.block.selector());

	if( !$oddsGrid ){
		return;
	}

	new OddsGrid($oddsGrid); // eslint-disable-line no-new
};



// WEBPACK FOOTER //
// ./src/js/layout/odds-grid.js